import styled from "styled-components";

export const AlertLinkWrapper = styled.div`
  cursor: pointer;
`;

export const PromosOnboardingWrapper = styled.div`
  max-width: 159px;
`;
